// Traductions FR / EN pour Kiwami Studios & Co

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      training: "Formation",
      about: "Studio",
      contact: "Contact",
      order: "Commander",
    },

    // Marque
    brand: {
      tagline: "Studio de photographie premium",
      baseline:
        "L'image taillée avec précision. Du chantier à la lumière de studio.",
    },

    // Accueil
    home: {
      hero_overline: "Kiwami · Mastery",
      hero_title_1: "L'instant,",
      hero_title_2: "magnifié.",
      hero_sub:
        "Photographie de chantier, de sport, d'événement, de marque — et la formation qui fait les photographes de demain.",
      hero_cta_primary: "Demander un devis",
      hero_cta_secondary: "Explorer les services",
      scroll: "Défiler",

      about_overline: "À propos de Kiwami Studios & Co",
      about_title: "Un regard, une discipline, un rendu.",
      about_body:
        "Kiwami Studios & Co accompagne les marques, promoteurs, clubs et institutions avec une exigence éditoriale. Chaque prise de vue est préparée, mesurée, signée. Notre studio intervient sur tous vos projets — du casque de chantier au tapis rouge.",
      about_cta: "Découvrir notre démarche",

      services_overline: "Nos disciplines",
      services_title: "Sept univers. Une même signature.",
      services_sub:
        "Chaque activité bénéficie d'un protocole dédié : repérage, direction, lumière, post-production, livraison.",

      works_overline: "Sélection récente",
      works_title: "Quelques images.",
      works_cta: "Voir tous les portfolios",

      cta_overline: "Prêt à collaborer ?",
      cta_title: "Parlons de votre projet.",
      cta_sub:
        "Devis sous 24h. Équipe mobile en local et à l'international.",
      cta_button: "Ouvrir un dossier",
    },

    // Services (page listing)
    services_page: {
      overline: "Services",
      title: "Disciplines & expertises.",
      sub: "De la photographie d'infrastructure à la formation, chaque discipline répond à un cahier des charges précis.",
    },

    // Détail par service
    services: {
      btp: {
        label: "BTP & Architecture",
        tagline: "Chantiers, ouvrages, livraisons.",
        description:
          "Documentation photographique d'ouvrages en cours et livrés. Suivi de chantier, photographie d'architecture, reportage pour promoteurs, bureaux d'étude et majors du BTP. Images sécurisées, cadrées aux plans, livrées en banque d'images structurée.",
        highlights: [
          "Suivi de phase (terrassement → livraison)",
          "Vues drone agréées et photographies d'intérieur",
          "Livrables haute définition pour éditions & plaquettes",
          "Conformité EPI et protocoles chantier",
        ],
      },
      events: {
        label: "Événementiel",
        tagline: "Mariages, galas, lancements.",
        description:
          "Couverture complète de vos événements privés et corporate : mariages d'exception, galas, soirées de marque, inaugurations. Une approche documentaire élégante qui capture l'émotion sans dicter l'instant.",
        highlights: [
          "Couverture multi-photographes",
          "Livraison express sous 72h (teaser)",
          "Album premium cuir & tirage fine art",
          "Vidéo compatible sur demande",
        ],
      },
      sports: {
        label: "Sport & Performance",
        tagline: "Action, vitesse, tension.",
        description:
          "Reportage sportif pour clubs, fédérations, équipementiers et sponsors. Photographie d'action en haute cadence, portraits d'athlètes, couverture de compétitions. Images calibrées pour les médias et les campagnes.",
        highlights: [
          "Couverture live & post-traitement accéléré",
          "Portraits d'athlètes en studio ou extérieur",
          "Accréditations presse organisables",
          "Formats verticaux & horizontaux livrés",
        ],
      },
      corporate: {
        label: "Corporate",
        tagline: "Portraits, équipes, locaux.",
        description:
          "Portraits d'équipe et dirigeants, photographies de locaux, reportages RH et rapports annuels. Une image professionnelle qui incarne la culture de votre entreprise, sans rigidité.",
        highlights: [
          "Portraits LinkedIn & dirigeants",
          "Reportage métiers & vie d'entreprise",
          "Photographies de locaux & showrooms",
          "Charte image déployable sur 5 ans",
        ],
      },
      advertising: {
        label: "Publicité de marque",
        tagline: "Campagnes, packshots, éditorial.",
        description:
          "Campagnes publicitaires, packshots produits et visuels éditoriaux pour les marques. De la conception au shooting, notre studio prend en charge l'intégralité de la direction artistique avec un rendu haut de gamme.",
        highlights: [
          "Direction artistique & casting",
          "Studio produit & packshots",
          "Campagnes print / digital",
          "Retouche haute couture (beauty & mode)",
        ],
      },
      training: {
        label: "Formation Photographie",
        tagline: "Transmettre le métier.",
        description:
          "Formations professionnelles et certifiantes pour amateurs avancés et professionnels. De la maîtrise technique à la direction de shooting, apprenez auprès de photographes actifs en intensif ou sur plusieurs week-ends.",
        highlights: [
          "Essentiels du reflex et hybride",
          "Portrait, lumière & direction modèle",
          "Post-production Lightroom & Capture One",
          "Masterclass business photographie",
        ],
      },
      phototheque: {
        label: "Photothèque Event",
        tagline: "Retrouvez-vous en un selfie.",
        description:
          "La Photothèque Event est notre service de reconnaissance faciale dédié aux événements : marathons, festivals, galas, conférences, congrès, mariages. Après l'événement, chaque invité ouvre la galerie, prend un selfie en direct depuis son téléphone — et notre intelligence artificielle lui retourne instantanément toutes les photos sur lesquelles il apparaît. Plus besoin de scroller des centaines de clichés : chaque participant accède en quelques secondes à sa propre sélection, prête à être téléchargée et partagée.",
        highlights: [
          "Recherche par selfie — résultats en moins de 10 secondes",
          "Galerie protégée par lien unique (zéro photo publique)",
          "Téléchargement HD individuel ou en album zip",
          "Partage 1-clic vers Instagram, WhatsApp, Facebook",
          "RGPD-friendly — empreintes faciales supprimées après l'événement",
          "Branding personnalisé : logo client, sponsors, couleurs",
        ],
        embed_title: "Galerie en direct",
        embed_overline: "Photothèque",
        embed_intro:
          "Sélectionnez votre événement ci-dessous, autorisez la caméra de votre téléphone, prenez un selfie — la photothèque vous retournera automatiquement toutes les photos sur lesquelles vous apparaissez.",
        how_overline: "Comment ça marche",
        how_title: "Trois étapes. Zéro friction.",
        how_step_1_label: "01 — Choisissez votre événement",
        how_step_1_body:
          "Sélectionnez l'événement couvert par Kiwami Studios dans la galerie ci-dessous.",
        how_step_2_label: "02 — Prenez un selfie",
        how_step_2_body:
          "Votre smartphone ouvre la caméra avant. Un seul cliché suffit — pas besoin de compte, pas d'application à installer.",
        how_step_3_label: "03 — Téléchargez vos photos",
        how_step_3_body:
          "Notre IA scanne instantanément la galerie et vous retourne uniquement les photos où vous apparaissez. Téléchargement HD, partage social, album cadeau.",
      },
    },

    // Page services détail partagée
    detail: {
      overview: "Aperçu",
      approach: "Approche",
      portfolio: "Portfolio",
      request: "Demander cette prestation",
      back: "Retour aux services",
      other_services: "Autres disciplines",
      share: "Partager cette page",
      share_copied: "Lien copié !",
      share_whatsapp: "WhatsApp",
      share_linkedin: "LinkedIn",
      share_facebook: "Facebook",
      share_twitter: "X (Twitter)",
      share_copy: "Copier le lien",
    },

    // Formation
    training_page: {
      overline: "Formation",
      title: "Apprendre la photographie à Kiwami.",
      sub: "Programmes conçus et dispensés par des photographes professionnels en activité. Petits groupes, pratique intensive, suivi post-formation.",
      courses_title: "Programmes",
      cta_title: "Envie de rejoindre une session ?",
      cta_sub: "Écrivez-nous pour connaître les prochaines dates.",
      cta_button: "S'inscrire",
      level: "Niveau",
      duration: "Durée",
      price: "Tarif",
    },
    courses: {
      essentials: {
        title: "Les Essentiels",
        description:
          "Reflex, hybride, composition, exposition, lumière naturelle. La base posée proprement.",
      },
      portrait: {
        title: "Portrait & Lumière",
        description:
          "Direction modèle, lumière artificielle, objectifs, retouche peau. Un week-end intensif en studio.",
      },
      advanced: {
        title: "Avancé & Business",
        description:
          "Campagne, direction artistique, relation client, cahier des charges. Se professionnaliser.",
      },
    },

    // Contact
    contact_page: {
      overline: "Contact",
      title: "Ouvrons le dossier.",
      sub: "Remplissez ce formulaire ou joignez-nous directement. Nous revenons vers vous sous 24 heures ouvrées.",
      direct_title: "Joindre directement",
      phone_label: "Téléphone / WhatsApp",
      call_cta: "Appeler maintenant",
      email_label: "Email",
      form_title: "Formulaire de commande",
      form_name: "Nom complet",
      form_email: "Email",
      form_phone: "Téléphone",
      form_service: "Type de prestation",
      form_service_placeholder: "Sélectionner une prestation",
      form_details: "Détails du projet",
      form_details_placeholder:
        "Décrivez votre projet : contexte, lieu, durée, livrables attendus...",
      form_budget: "Budget indicatif (optionnel)",
      form_date: "Date souhaitée (optionnel)",
      form_submit: "Envoyer la demande",
      form_submitting: "Envoi...",
      form_success: "Demande reçue. Nous vous répondons sous 24h.",
      form_error: "Une erreur est survenue. Merci de réessayer.",
      required: "Champs requis",
    },

    // About
    about_page: {
      overline: "Studio",
      title: "Kiwami Studios & Co.",
      body_1:
        "Kiwami est un mot japonais qui signifie « la maîtrise absolue ». C'est l'exigence que nous appliquons à chaque image, chaque projet, chaque client.",
      body_2:
        "Notre studio intervient sur tous vos besoins photographiques : BTP, événementiel, sport, corporate, publicité — et transmet ce savoir à travers des formations certifiantes.",
      body_3:
        "Nous travaillons avec des marques internationales, des promoteurs, des clubs professionnels et des institutions publiques. Chaque collaboration est pensée comme une œuvre sur mesure.",
      values_title: "Nos valeurs",
      v1_title: "Discipline",
      v1_body:
        "Préparation rigoureuse, exécution propre, livraison dans les temps.",
      v2_title: "Sens du détail",
      v2_body: "Un cadrage pensé, une lumière mesurée, une retouche invisible.",
      v3_title: "Confidentialité",
      v3_body:
        "NDA standard, stockage sécurisé, livrables cryptés pour nos clients sensibles.",
    },

    // Footer
    footer: {
      rights: "Tous droits réservés.",
      made_in: "",
      nav_title: "Navigation",
      services_title: "Services",
      contact_title: "Contact",
    },

    common: {
      discover: "Découvrir",
      read_more: "Lire la suite",
      view: "Voir",
      yes: "Oui",
      no: "Non",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      training: "Training",
      about: "Studio",
      contact: "Contact",
      order: "Order",
    },

    brand: {
      tagline: "Premium photography studio",
      baseline:
        "Imagery sculpted with precision. From construction site to studio light.",
    },

    home: {
      hero_overline: "Kiwami · Mastery",
      hero_title_1: "The moment,",
      hero_title_2: "magnified.",
      hero_sub:
        "Construction, sport, event, brand photography — and the training that shapes tomorrow's photographers.",
      hero_cta_primary: "Request a quote",
      hero_cta_secondary: "Explore services",
      scroll: "Scroll",

      about_overline: "About Kiwami Studios & Co",
      about_title: "One eye, one discipline, one signature.",
      about_body:
        "Kiwami Studios & Co partners with brands, developers, clubs and institutions with editorial rigor. Every shoot is prepared, measured, signed. Our studio operates on all your projects — from hard hats to red carpets.",
      about_cta: "Discover our approach",

      services_overline: "Our disciplines",
      services_title: "Seven worlds. One signature.",
      services_sub:
        "Each discipline follows a dedicated protocol: scouting, direction, light, post-production, delivery.",

      works_overline: "Selected work",
      works_title: "A few frames.",
      works_cta: "See all portfolios",

      cta_overline: "Ready to collaborate?",
      cta_title: "Let's talk about your project.",
      cta_sub:
        "Quote within 24 hours. Team available locally and internationally.",
      cta_button: "Open a brief",
    },

    services_page: {
      overline: "Services",
      title: "Disciplines & expertise.",
      sub: "From infrastructure photography to training, each discipline answers a precise brief.",
    },

    services: {
      btp: {
        label: "Construction & Architecture",
        tagline: "Sites, buildings, delivery.",
        description:
          "Photographic documentation of ongoing and delivered construction projects. Site follow-up, architecture photography, editorial reportage for developers, engineering firms and BTP majors. Secured images, plan-aligned framing, delivered as a structured image bank.",
        highlights: [
          "Phase tracking (earthworks → delivery)",
          "Certified drone views and interior shots",
          "High-resolution deliverables for print & brochures",
          "PPE-compliance and site protocols",
        ],
      },
      events: {
        label: "Events",
        tagline: "Weddings, galas, launches.",
        description:
          "Full coverage of private and corporate events: signature weddings, galas, brand nights, openings. A documentary-elegant approach that captures emotion without dictating the moment.",
        highlights: [
          "Multi-photographer coverage",
          "Express 72h teaser delivery",
          "Premium leather album & fine-art prints",
          "Compatible video on request",
        ],
      },
      sports: {
        label: "Sport & Performance",
        tagline: "Action, speed, tension.",
        description:
          "Sports reportage for clubs, federations, outfitters and sponsors. High-frame-rate action, athlete portraits, competition coverage. Images calibrated for media and brand campaigns.",
        highlights: [
          "Live coverage & fast post-production",
          "Athlete portraits — studio or outdoor",
          "Press accreditation support",
          "Vertical & horizontal formats delivered",
        ],
      },
      corporate: {
        label: "Corporate",
        tagline: "Portraits, teams, premises.",
        description:
          "Team & executive portraits, premises photography, HR reporting and annual reports. A professional image that embodies your company culture, without rigidity.",
        highlights: [
          "LinkedIn & executive portraits",
          "Reportage: operations & culture",
          "Premises & showroom photography",
          "5-year visual brand guideline",
        ],
      },
      advertising: {
        label: "Brand Advertising",
        tagline: "Campaigns, packshots, editorial.",
        description:
          "Advertising campaigns, product packshots and editorial visuals for brands. From concept to shoot, our studio handles full art direction with a high-end finish.",
        highlights: [
          "Art direction & casting",
          "Product studio & packshots",
          "Print / digital campaigns",
          "High-end retouching (beauty & fashion)",
        ],
      },
      training: {
        label: "Photography Training",
        tagline: "Passing on the craft.",
        description:
          "Professional and certifying training for advanced amateurs and professionals. From technical mastery to shoot direction, learn from working photographers in intensive formats or over weekends.",
        highlights: [
          "DSLR & mirrorless essentials",
          "Portrait, lighting & model direction",
          "Post-production: Lightroom & Capture One",
          "Photography business masterclass",
        ],
      },
      phototheque: {
        label: "Event Photo Library",
        tagline: "Find yourself with one selfie.",
        description:
          "The Event Photo Library is our face-recognition service built for events: marathons, festivals, galas, conferences, weddings. After the event, every guest opens the gallery, takes a live selfie from their phone — and our AI instantly returns every photo they appear in. No more scrolling through hundreds of frames: each attendee accesses their own curated selection in seconds, ready to download and share.",
        highlights: [
          "Selfie search — results in under 10 seconds",
          "Gallery protected by unique link (no public photos)",
          "Individual HD download or full zip album",
          "1-click sharing to Instagram, WhatsApp, Facebook",
          "GDPR-friendly — facial fingerprints deleted after the event",
          "Custom branding: client logo, sponsors, colors",
        ],
        embed_title: "Live gallery",
        embed_overline: "Photo library",
        embed_intro:
          "Pick your event below, allow your phone's camera, take a selfie — the photo library will automatically return every photo you appear in.",
        how_overline: "How it works",
        how_title: "Three steps. Zero friction.",
        how_step_1_label: "01 — Pick your event",
        how_step_1_body:
          "Select the event covered by Kiwami Studios from the gallery below.",
        how_step_2_label: "02 — Take a selfie",
        how_step_2_body:
          "Your phone opens the front camera. One shot is enough — no account, no app to install.",
        how_step_3_label: "03 — Download your photos",
        how_step_3_body:
          "Our AI instantly scans the gallery and returns only the photos you appear in. HD download, social sharing, gift album.",
      },
    },

    detail: {
      overview: "Overview",
      approach: "Approach",
      portfolio: "Portfolio",
      request: "Request this service",
      back: "Back to services",
      other_services: "Other disciplines",
      share: "Share this page",
      share_copied: "Link copied!",
      share_whatsapp: "WhatsApp",
      share_linkedin: "LinkedIn",
      share_facebook: "Facebook",
      share_twitter: "X (Twitter)",
      share_copy: "Copy link",
    },

    training_page: {
      overline: "Training",
      title: "Learn photography at Kiwami.",
      sub: "Programs designed and taught by working professional photographers. Small groups, intensive practice, post-training follow-up.",
      courses_title: "Programs",
      cta_title: "Want to join a session?",
      cta_sub: "Write to us to find out the next dates.",
      cta_button: "Enroll",
      level: "Level",
      duration: "Duration",
      price: "Price",
    },
    courses: {
      essentials: {
        title: "The Essentials",
        description:
          "DSLR, mirrorless, composition, exposure, natural light. The basics laid down cleanly.",
      },
      portrait: {
        title: "Portrait & Light",
        description:
          "Model direction, artificial light, lenses, skin retouching. An intensive studio weekend.",
      },
      advanced: {
        title: "Advanced & Business",
        description:
          "Campaign, art direction, client relationship, brief. Go professional.",
      },
    },

    contact_page: {
      overline: "Contact",
      title: "Let's open the brief.",
      sub: "Fill out this form or reach us directly. We reply within 24 business hours.",
      direct_title: "Reach out directly",
      phone_label: "Phone / WhatsApp",
      call_cta: "Call now",
      email_label: "Email",
      form_title: "Order form",
      form_name: "Full name",
      form_email: "Email",
      form_phone: "Phone",
      form_service: "Service type",
      form_service_placeholder: "Select a service",
      form_details: "Project details",
      form_details_placeholder:
        "Describe your project: context, location, duration, expected deliverables...",
      form_budget: "Budget range (optional)",
      form_date: "Preferred date (optional)",
      form_submit: "Send request",
      form_submitting: "Sending...",
      form_success: "Request received. We'll reply within 24h.",
      form_error: "An error occurred. Please try again.",
      required: "Required fields",
    },

    about_page: {
      overline: "Studio",
      title: "Kiwami Studios & Co.",
      body_1:
        "Kiwami is a Japanese word meaning 'absolute mastery'. It's the standard we apply to every image, every project, every client.",
      body_2:
        "Our studio supports all your photographic needs: BTP, events, sports, corporate, advertising — and passes on this knowledge through certifying training.",
      body_3:
        "We work with international brands, developers, professional clubs and public institutions. Every collaboration is crafted as bespoke work.",
      values_title: "Our values",
      v1_title: "Discipline",
      v1_body: "Rigorous preparation, clean execution, on-time delivery.",
      v2_title: "Detail",
      v2_body: "Thoughtful framing, measured light, invisible retouching.",
      v3_title: "Confidentiality",
      v3_body:
        "Standard NDA, secure storage, encrypted deliverables for sensitive clients.",
    },

    footer: {
      rights: "All rights reserved.",
      made_in: "",
      nav_title: "Navigation",
      services_title: "Services",
      contact_title: "Contact",
    },

    common: {
      discover: "Discover",
      read_more: "Read more",
      view: "View",
      yes: "Yes",
      no: "No",
    },
  },
};
